import { Component, OnInit } from '@angular/core';
import { IHeaderTitle } from 'app/shared/models/header-title';
import { ActivatedRoute } from '@angular/router';
import { CompanyService } from 'app/company/services/company.service';
import { CompanyDetailsModel } from 'app/company/models/company-details-model';

@Component({
    selector: 'app-company-audit-list-tab',
    templateUrl: './company-audit-list-tab.component.html',
    styleUrls: ['./company-audit-list-tab.component.css']
})
export class CompanyAuditListTabComponent implements OnInit {
    headerTitle: IHeaderTitle;
    companyId: string;
    companyDetailsModel: CompanyDetailsModel;
    selectedTab: number = 1;

    constructor(
        private activatedRoute: ActivatedRoute,
        private companyService: CompanyService
    ) {
    }

    ngOnInit() {
        this.companyId = this.activatedRoute.snapshot.params['id'];
        this.companyService.get(this.companyId).subscribe(companyInfo => {
            this.companyDetailsModel = companyInfo;
            this.headerTitle = {
                title: companyInfo.legalName,
                breadcrumbs: [{ title: 'Companies', url: ['/company'] }]
            };
        });
    }
}
